if (!customElements.get('read-more')) {
  class ReadMore extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.read-more__content');
      this.buttons = this.querySelectorAll('.read-more__action');
      this.section = this.parentElement;

      this.headerHeight = +document.querySelector('html').style.getPropertyValue('--header-height').replace('px', '') || 0;

      this.setUpContent();
    }
    setUpContent() {
      if (this.content.textContent.trim() === '') {
        this.section.classList.add('hidden')
        return;
      }

      this.setResponsive();
      window.addEventListener('resize', this.setResponsive.bind(this));
      this.buttons.forEach(button => {
        button.addEventListener('click', this.onClick.bind(this));
      })
    }
    onClick() {
      this.content.getAttribute('open') == null
        ? this.content.setAttribute('open', '')
        : this.content.removeAttribute('open');

      window.scroll({
        top: this.parentElement.offsetTop - this.headerHeight,
        left: 0,
        behavior: 'smooth'
      })
    }
    setResponsive() {
      this.content.style.setProperty('--max-height', this.content.scrollHeight + 'px');
      this.content.scrollHeight < +this.content.dataset.desktop
        ? this.classList.add('hide-desktop')
        : this.classList.remove('hide-desktop')

      this.content.scrollHeight < +this.content.dataset.mobile
        ? this.classList.add('hide-mobile')
        : this.classList.remove('hide-mobile')
    }
  }

  customElements.define('read-more', ReadMore)
}